import { useState } from 'react'
import { Form, Head } from '@inertiajs/react'
import { Input, Button } from 'antd'

import LoginLayout from '@/components/layouts/LoginLayout'
import DeviceUserCard from '@/components/DeviceUserCard'

interface ForgotPasswordProps {
  csrf_token: string
}

export default function ForgotPassword({ csrf_token }: ForgotPasswordProps) {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  return (
    <LoginLayout title="Reset Password">
      <Head title="Reset Password" />
      <DeviceUserCard title="Forgot your password?">
        <p className="text-sm text-gray-600 text-center mb-4">
          Enter your email address and we will send you instructions to reset your password.
        </p>
        <Form
          action="/password"
          method="post"
          onSubmit={() => setLoading(true)}
          onSuccess={() => setLoading(false)}
          onError={() => setLoading(false)}
        >
          <input type="hidden" name="authenticity_token" value={csrf_token} />
          <div className="mb-4">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <Input
              id="email"
              name="user[email]"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="ant-input w-full"
              placeholder="Enter your email"
              required
            />
          </div>
          <div className="mt-4">
            <Button
              type="primary"
              htmlType="submit"
              className="w-full text-white border-none rounded font-medium cursor-pointer mt-2 block"
              loading={loading}
            >
              Send reset instructions
            </Button>
          </div>
        </Form>
        <div className="mt-4 text-center">
          <a className="text-blue-500 text-sm" href="/login">
            Back to login
          </a>
        </div>
      </DeviceUserCard>
    </LoginLayout>
  )
}
